"use client";
import React, { createContext, useContext, useState, ReactNode } from "react";

// Typen für den globalen Store
interface GlobalStore {
  headerVariant: "light" | "dark" | undefined;
  setHeaderVariant: (variant: "light" | "dark" | undefined) => void;
  footerVariant: "light" | "dark" | undefined;
  setFooterVariant: (variant: "light" | "dark" | undefined) => void;
  mobileMenuActive: boolean;
  setMobileMenuActive: (active: boolean) => void;
}

const GlobalStoreContext = createContext<GlobalStore | undefined>(undefined);

export const GlobalStoreProvider = ({ children }: { children: ReactNode }) => {
  const [headerVariant, setHeaderVariant] =
    useState<GlobalStore["headerVariant"]>("dark");
  const [footerVariant, setFooterVariant] =
    useState<GlobalStore["footerVariant"]>("dark");
  const [mobileMenuActive, setMobileMenuActive] = useState<boolean>(false);

  return (
    <GlobalStoreContext.Provider
      value={{
        headerVariant,
        setHeaderVariant,
        footerVariant,
        setFooterVariant,
        mobileMenuActive,
        setMobileMenuActive,
      }}
    >
      {children}
    </GlobalStoreContext.Provider>
  );
};

export function useGlobalStore() {
  const context = useContext(GlobalStoreContext);
  if (!context) {
    throw new Error(
      "useGlobalStore muss innerhalb des GlobalStoreProvider verwendet werden!"
    );
  }
  return context;
}
